module.exports = __webpack_public_path__ + "img/bg19.9ddea7fe.png";